import { render } from "./PressLogoStrip.vue?vue&type=template&id=227ad7b3&scoped=true"
import script from "./PressLogoStrip.vue?vue&type=script&lang=js"
export * from "./PressLogoStrip.vue?vue&type=script&lang=js"

import "./PressLogoStrip.vue?vue&type=style&index=0&id=227ad7b3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227ad7b3"]])

export default __exports__